import withDelayedHoverEvent from "app/pages/sales-intelligence/hoc/withDelayedHoverEvent";
import type { ComponentPropsWithoutRef } from "react";
import ColumnSuggestionsTooltipContent from "../../components/ColumnSuggestionsTooltipContent/ColumnSuggestionsTooltipContent";
import { columnsSuggestionsTrackingService } from "../../services/columnSuggestionsTrackingService";

const ColumnSuggestionsTooltipWithHoverEvents = withDelayedHoverEvent(ColumnSuggestionsTooltipContent);

const ColumnSuggestionsTooltipContentTracked = (
    props: ComponentPropsWithoutRef<typeof ColumnSuggestionsTooltipContent>,
) => {
    const handleOnApplyClickTracked = (columnNames: readonly string[]) => {
        columnsSuggestionsTrackingService.trackApplyClicked(props.columnsSuggestions.length, columnNames.length);
        props.onApplyClick(columnNames);
    };

    function handleCancelClickTracked(): void {
        columnsSuggestionsTrackingService.trackCancelClicked(props.columnsSuggestions.length);
        props.onCancelClick();
    }

    const handleOnMouseEnter = () => {
        columnsSuggestionsTrackingService.trackTooltipHovered(props.columnsSuggestions.length);
    };

    return (
        <ColumnSuggestionsTooltipWithHoverEvents
            {...props}
            onApplyClick={handleOnApplyClickTracked}
            onCancelClick={handleCancelClickTracked}
            onMouseEnter={handleOnMouseEnter}
        />
    );
};

export default ColumnSuggestionsTooltipContentTracked;
